// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2DtR6","list":"PatternAutocomplete_list__PLkHQ"};